import { FiCheck } from "react-icons/fi";
import { Action, ActionProps } from "../action";

export const Complete = (props: ActionProps) => {
  return <Action {...props} Icon={FiCheck} variant="default" />;
};
